// extracted by mini-css-extract-plugin
module.exports = {"card":"person_card__aK2BD"};